import { ReactNode } from 'react';
import { useLocation, Link } from 'react-router-dom';
import GlobalHeader from './GlobalHeader';

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    const location = useLocation();
    const isAppRoute = location.pathname === '/studio' || location.pathname === '/diagnose';

    return (
        <div 
            className="flex flex-col bg-dark text-gray-200 selection:bg-primary/30"
            style={isAppRoute ? { height: '100dvh', overflow: 'hidden' } : { minHeight: '100vh' }}
        >
            <GlobalHeader />
            <main 
                className="flex-1 flex flex-col min-w-0"
                style={isAppRoute ? { height: 'calc(100dvh - 64px)', overflow: 'hidden' } : {}}
            >
                {children}
            </main>
            {!isAppRoute && (
                <footer className="border-t border-slate/10 py-12 px-6 bg-dark/80 backdrop-blur-md">
                    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
                        <div className="space-y-4 text-center md:text-left">
                            <p className="text-[10px] text-gray-400 uppercase tracking-widest font-black">
                                © 2026 DIYELECTRONICMECH • POWERED BY ELECTRAI CORE
                            </p>
                            <p className="text-[11px] text-gray-300/90 max-w-sm mx-auto md:mx-0">
                                AI-powered electronics troubleshooting, circuit schematics, component datasheet lookup, and maker project guides.
                            </p>
                        </div>
                        <div className="flex flex-wrap justify-center md:justify-end gap-x-12 gap-y-4">
                            <div className="flex flex-col gap-3">
                                <span className="text-[10px] text-gray-400 font-black uppercase tracking-widest">Platform</span>
                                <Link to="/privacy" className="text-[11px] text-gray-300 uppercase tracking-widest font-bold hover:text-white transition-colors">Privacy Policy</Link>
                                <Link to="/terms" className="text-[11px] text-gray-300 uppercase tracking-widest font-bold hover:text-white transition-colors">Terms of Service</Link>
                            </div>
                            <div className="flex flex-col gap-3">
                                <span className="text-[10px] text-gray-400 font-black uppercase tracking-widest">Resources</span>
                                <Link to="/learn" className="text-[11px] text-gray-300 uppercase tracking-widest font-bold hover:text-white transition-colors">Learning Hub</Link>
                                <Link to="/faq" className="text-[11px] text-gray-300 uppercase tracking-widest font-bold hover:text-white transition-colors">FAQ & Support</Link>
                            </div>
                            <div className="flex flex-col gap-3">
                                <span className="text-[10px] text-gray-400 font-black uppercase tracking-widest">Company & Pricing</span>
                                <Link to="/about" className="text-[11px] text-gray-300 uppercase tracking-widest font-bold hover:text-white transition-colors">About Us</Link>
                                <Link to="/upgrade" className="text-[11px] text-gray-300 uppercase tracking-widest font-bold hover:text-white transition-colors">Pricing & Pro</Link>
                            </div>
                        </div>
                    </div>
                </footer>
            )}
        </div>
    );
}
